/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * API service to wrap the Data from vchan to format between
 * SDK and client.
 * We need to extend this class when add multiple add-in support
 *
 * For HTML access and Chrome the message flow is not the same.
 * Since we only support Chrome Client in the first version
 * hook this to the middle man service for Chrome Client
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { ChannelDescriptor, VCMessage } from "./vc-client";
import { Logger } from "../../../../core/libs/logger";
import { VCChannel } from "./channel-manager";
export { VCMessage } from "./vc-client";

@Injectable()
export abstract class VcClientAPI {
   protected sendFunctions;
   protected channelManager;
   protected logger = new Logger(Logger.RDPVCBRIDGE, null, Logger.Modules.RDPVCBridge);
   protected inited = false;
   protected channelhelper;
   constructor() {}
   public abstract init(uuid, sessionKey, channelOptions, sendFunction, featureName): void;
   public abstract onReceiveVChanData(channelInfo: ChannelDescriptor, data: Uint8Array): void;
   public abstract onVchanConnected(channelInfo: ChannelDescriptor): void;
   public abstract onVchanDisconnected(channelInfo: ChannelDescriptor): void;

   public sendOnVchan = (vcMessage: VCMessage) => {
      const channelInfo = vcMessage.channelInfo;
      const data = vcMessage.data;
      const vChannel: VCChannel = this.channelManager.getChannel(channelInfo);
      if (!vChannel) {
         this.logger.warning("failed to find a channel to send message");
         return;
      }
      this.logger.trace("send vchan message on " + vChannel.getName());
      this.logger.dump("message data: " + JSON.stringify(data));
      vChannel.send(Uint8Array.from(data));
   };
}
